import { render } from "./LoansTable.vue?vue&type=template&id=0f992de4&scoped=true"
import script from "./LoansTable.vue?vue&type=script&lang=js"
export * from "./LoansTable.vue?vue&type=script&lang=js"

import "./LoansTable.vue?vue&type=style&index=0&id=0f992de4&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f992de4"]])

export default __exports__